import { render } from "./ConsultaSaldosContables.vue?vue&type=template&id=0506d397&scoped=true"
import script from "./ConsultaSaldosContables.vue?vue&type=script&lang=js"
export * from "./ConsultaSaldosContables.vue?vue&type=script&lang=js"

import "./ConsultaSaldosContables.vue?vue&type=style&index=0&id=0506d397&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0506d397"]])

export default __exports__